import { create } from "zustand";
import { persist } from "zustand/middleware";

interface SidebarStore {
    collapsed: boolean;
    toggleCollapsed: () => void;
    setCollapsed: (collapsed: boolean) => void;
}

export const useSidebarStore = create<SidebarStore>()(
    persist(
        (set, get) => ({
            collapsed: false,

            toggleCollapsed: () => {
                set({ collapsed: !get().collapsed });
            },

            setCollapsed: (collapsed: boolean) => {
                set({ collapsed });
            },
        }),
        {
            name: "merchant-portal-sidebar",
        },
    ),
);
